export default __webpack_public_path__ + "d0df1e69ef6bb73839dfd1fad82074e6.png";